import { render, staticRenderFns } from "./TerritoryCheckMap.vue?vue&type=template&id=4984e2f5&scoped=true&"
import script from "./TerritoryCheckMap.vue?vue&type=script&lang=js&"
export * from "./TerritoryCheckMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4984e2f5",
  null
  
)

export default component.exports